export default __webpack_public_path__ + "static/Nude-f9bdfd2e85eabe29ece7e1899827c861.png";